"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _ThemeProvider = require("../../../components/ThemeProvider");

var _Avatar = require("../Avatar");

var _style = _interopRequireDefault(require("./style"));

var _colours = _interopRequireDefault(require("../Avatar/colours"));

var _classnames = _interopRequireDefault(require("classnames"));

/* eslint-disable complexity */
var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);

var LogoBanner = function LogoBanner(_ref) {
  var logoURL = _ref.logoURL,
      companyName = _ref.companyName,
      className = _ref.className,
      onClick = _ref.onClick,
      noGradient = _ref.noGradient,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["logoURL", "companyName", "className", "onClick", "noGradient"]);

  var _useState = (0, _react.useState)(!!logoURL),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      showImage = _useState2[0],
      setShowImage = _useState2[1];

  (0, _react.useEffect)(function () {
    setShowImage(!!logoURL);
  }, [logoURL]);

  var handleOnError = function handleOnError(event) {
    if ((event === null || event === void 0 ? void 0 : event.type) === 'error') {
      setShowImage(false);
    }
  };

  var theme = (0, _ThemeProvider.useTheme)();
  var classes = useStyles({
    theme: theme,
    props: {
      background: showImage ? 'none' : (0, _Avatar.getRandomColor)(companyName, _colours["default"]),
      cursor: onClick ? 'pointer' : 'default'
    }
  });
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])(className, classes.LogoBanner),
    onClick: onClick
  }, rest), !noGradient && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.Gradient
  }), showImage ? /*#__PURE__*/_react["default"].createElement("img", {
    className: classes.Image,
    src: logoURL,
    onError: handleOnError,
    alt: companyName || ''
  }) : /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.Text
  }, companyName));
};

exports["default"] = LogoBanner;
//# sourceMappingURL=index.js.map